import "../../compositions/FinancialEnquiry/EnquiryReview/index.css";
import { detectMobile } from '../../utils/formatting';
const isMobile = detectMobile();

export const getValueOrDefault = (value: any, defaultValue: string = "-"): string => {

    if(value !== null && value !== undefined && value !== "") 
    {
        return value
    }else{
        return defaultValue
    }
    
  };

  export const generateErrorMessage = (msg:string) => {
    return (
      <>
        {msg}
        {isMobile ? <a href="tel:03001233456" className="color-black">03001233456. </a> : "03001233456. \n"}
        <br></br>
        <br></br>
        {<a href="/customer360View" className="color-black">Return to Home</a>}
      </>
    );
  };  